/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f287234ac32592903bc0c70b69a3812068f8ad90";
